import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRoom, IRoomInitialState } from "./roomModal";
import {
  ActiveInactiveRoom,
  createRoom,
  deleteRoom,
  getAllActiveRooms,
  getAllRooms,
  getRoomByID,
  RoomImageUpload,
  updateRoom,
} from "./services/room.services";

const initialState: IRoomInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  RoomID: null,
  RoomList: [],
  RoomDetail: {
    ID: null,
    RoomTitle: "",
    RoomCategory: "",
    Description: "",
    Rate: null,
    SqFoot: "",
    BedSize: "",
    Adults: "",
    RoomViewType: "",
    FacilityID: null,
    SequenceNo: null,
    Image: "",
    IsActive: 1,
  },
};

const roomSlice = createSlice({
  name: "room",
  initialState,
  reducers: {
    clearRoomDetails: (state) => {
      state.RoomDetail = initialState.RoomDetail;
    },
    setRoomID: (state, action) => {
      state.RoomID = action.payload;
    },
    clearRoomID: (state) => {
      state.RoomID = initialState.RoomID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllRooms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllRooms.fulfilled,
      (state, action: PayloadAction<IRoom[]>) => {
        state.loading = false;
        state.RoomList = action.payload || [];
      },
    );
    builder.addCase(getAllRooms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.RoomList = [];
    });
    builder.addCase(createRoom.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createRoom.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createRoom.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateRoom.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateRoom.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateRoom.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteRoom.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteRoom.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteRoom.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getRoomByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getRoomByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.RoomDetail = action.payload;
    });
    builder.addCase(getRoomByID.rejected, (state, action) => {
      state.formLoading = false;
      state.RoomDetail = initialState.RoomDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveRooms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveRooms.fulfilled,
      (state, action: PayloadAction<IRoom[]>) => {
        state.loading = false;
        state.RoomList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveRooms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.RoomList = [];
    });
    builder.addCase(ActiveInactiveRoom.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveRoom.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveRoom.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(RoomImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(RoomImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(RoomImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearRoomDetails, clearRoomID, setRoomID } = roomSlice.actions;
export default roomSlice.reducer;
